export default function useFamilySubscription (hubbleClient) {
  if (!hubbleClient) {
    throw new Error('You must provide the hubbleClient to use this composable');
  }
  const getChildSubscriptionsForFamilySubscription = async (parentSubscriptionId) => {
    const res = await hubbleClient.familySubscription.getChildSubscriptionsForFamilySubscription(parentSubscriptionId);
    return res.data;
  }

  return {
    getChildSubscriptionsForFamilySubscription
  }
}
